module.exports = __webpack_public_path__ + "static/media/promo-iptelephony.8e6fbfce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-iptelephony.jpg
// module id = 312
// module chunks = 0